import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import axios from "axios";
import router from "./router";
import VueGtm from "vue-gtm";
import Buefy from "buefy";

Vue.use(Buefy);

import i18n from "./i18n";

// TODO: Fill GTM with correct data.
// TODO: start tracking somewhere
Vue.use(VueGtm, {
  id: "GTM-WNLRJ32", // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
  //     gtm_auth:'xxxxxxxxx',
  //     gtm_preview:'env-4',
  //     gtm_cookies_win:'x'
  // },
  defer: true, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: false, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // If router, you can exclude some routes name (case insensitive) (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

let apiBaseUrl = "https://content.murtfeldt-as.de/";
//let apiBaseUrl = 'http://85.214.135.60:3000/cms/';

axios.defaults.baseURL = apiBaseUrl;

Vue.config.productionTip = false;

let Hyphenopoly = {
  require: {
    de: "Silbentrennungsalgorithmus",
    "en-us": "Supercalifragilisticexpialidocious",
  },
  setup: {
    selectors: {
      ".container": {},
    },
  },
};

Vue.filter("toCents", (value) => {
  return value * 100.0;
});

Vue.filter("currency", (value) => {
  if (!value) {
    return "CHF 0,00";
  }
  let formatter = new Intl.NumberFormat("de-CH", {
    style: "currency",
    currency: "CHF",
    minimumFractionDigits: 2,
  });
  return formatter.format((Math.round(value / 10) / 10).toFixed(2));
});

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
